import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { mockProperties } from '../data/mockData';
import * as FiIcons from 'react-icons/fi';

const { FiPlus, FiMapPin, FiMaximize, FiSettings, FiDollarSign, FiUsers } = FiIcons;

export default function Portfolio() {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="p-4 md:p-8 space-y-8">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-4 border-b border-[#004B87]/10 pb-6">
        <div>
          <h2 className="text-3xl font-light uppercase tracking-[0.2em] text-[#004B87]">Property Directory</h2>
          <p className="text-[10px] font-mono text-[#004B87]/40 mt-1 uppercase tracking-widest">
            AUM: 81 Units | Portfolio Health: 94.2%
          </p>
        </div>
        <button className="btn-rust flex items-center gap-2 px-6 py-3">
          <SafeIcon icon={FiPlus} /> Register New Asset
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {mockProperties.map((prop, i) => (
          <motion.div 
            initial={{ opacity: 0, y: 20 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ delay: i * 0.1 }}
            key={prop.id} 
            className="tech-panel group flex flex-col bg-white h-full"
          >
            {/* Aspect Ratio Controlled Media */}
            <div className="aspect-[16/10] overflow-hidden relative border-b border-[#004B87]/20 bg-[#004B87]/5">
              <div className="absolute inset-0 bg-[#004B87]/10 group-hover:bg-transparent transition-colors z-10 mix-blend-multiply"></div>
              <img 
                src={prop.image} 
                alt={prop.name} 
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 scale-105 group-hover:scale-100" 
                onError={(e) => {
                  e.target.src = 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=1200&auto=format&fit=crop';
                }}
              />
              <div className="absolute top-4 left-4 z-20 bg-[#FFFFF0] border border-[#004B87] px-3 py-1 text-[10px] font-mono font-bold text-[#004B87]">
                {prop.id}
              </div>
              <div className={`absolute bottom-4 right-4 z-20 px-3 py-1 text-[9px] font-mono uppercase tracking-widest border border-[#FFFFF0] text-[#FFFFF0] backdrop-blur-md
                ${prop.status === 'healthy' ? 'bg-green-600/80' : prop.status === 'maintenance' ? 'bg-[#004B87]/80' : 'bg-[#C1440E]/80'}`}>
                {prop.status}
              </div>
            </div>
            
            <div className="p-6 flex-1 flex flex-col">
              <div className="mb-4">
                <h3 className="text-xl font-bold uppercase tracking-wider text-[#004B87] group-hover:text-[#C1440E] transition-colors">{prop.name}</h3>
                <p className="text-[11px] text-[#004B87]/60 flex items-center gap-2 mt-1 font-mono uppercase truncate">
                  <SafeIcon icon={FiMapPin} className="text-[#C1440E]" /> {prop.address}
                </p>
              </div>
              
              <div className="grid grid-cols-2 gap-px bg-[#004B87]/10 border border-[#004B87]/10 mt-auto">
                <div className="p-3 bg-white">
                  <div className="flex items-center gap-2 text-[9px] uppercase tracking-widest text-[#004B87]/40 font-mono mb-1">
                    <SafeIcon icon={FiUsers} /> Capacity
                  </div>
                  <p className="text-xl font-light text-[#004B87]">{prop.units} <span className="text-[10px] font-mono text-[#004B87]/50 uppercase">Units</span></p>
                </div>
                <div className="p-3 bg-white">
                  <div className="flex items-center gap-2 text-[9px] uppercase tracking-widest text-[#004B87]/40 font-mono mb-1">
                    <SafeIcon icon={FiMaximize} /> Fill Rate
                  </div>
                  <p className="text-xl font-light text-[#004B87]">{prop.occupancy}%</p>
                </div>
                <div className="p-3 bg-white">
                  <div className="flex items-center gap-2 text-[9px] uppercase tracking-widest text-[#004B87]/40 font-mono mb-1">
                    <SafeIcon icon={FiDollarSign} /> Revenue
                  </div>
                  <p className="text-xl font-light text-[#004B87]">{prop.revenue}</p>
                </div>
                <div className="p-3 bg-white flex items-center justify-center">
                  <button className="w-full h-full flex items-center justify-center text-[#004B87]/40 hover:text-[#C1440E] transition-colors group/btn">
                    <SafeIcon icon={FiSettings} className="text-lg group-hover/btn:rotate-90 transition-transform duration-500" />
                  </button>
                </div>
              </div>

              <button className="w-full mt-6 btn-blueprint py-3 text-[10px]">
                Access Full Asset Ledger
              </button>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}